import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';

import { SmartScheduleOnboardingImage } from './SmartScheduleOnboardingImage';

import * as styles from './AllSet.module.less';

interface AllSetProps {
  onFinish: () => void;
  isFinishing: boolean;
}

export const AllSet = ({ onFinish, isFinishing }: AllSetProps) => {
  return (
    <div className={styles.container}>
      <h2>
        <FormattedMessage
          id="templates.smart_schedule.onboarding.all-set-heading"
          defaultMessage="You're all set!"
          description="Heading on the final onboarding confirmation page"
        />
      </h2>
      <Button
        appearance="primary"
        isLoading={isFinishing}
        isDisabled={isFinishing}
        onClick={onFinish}
      >
        <FormattedMessage
          id="templates.smart_schedule.onboarding.start-scheduling-cta"
          defaultMessage="Start scheduling my focus time"
          description="Primary call to action to begin scheduling focus time"
        />
      </Button>
      <SmartScheduleOnboardingImage />
    </div>
  );
};
